import { render, staticRenderFns } from "./PromptBody.vue?vue&type=template&id=731f63de&scoped=true&"
import script from "./PromptBody.vue?vue&type=script&lang=js&"
export * from "./PromptBody.vue?vue&type=script&lang=js&"
import style0 from "./PromptBody.vue?vue&type=style&index=0&id=731f63de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731f63de",
  null
  
)

export default component.exports